/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { TmHttpClient } from '@treasury/core/http';
import { Injectable } from '@treasury/utils/dependency-injection';
import { createSwaggerClient } from '../../utils/tm-swagger-client';

import { CountryModelDto } from '../';
import { HttpClient, RequestParams } from './http-client';

@Injectable()
export class CountriesClient {
    private readonly http: HttpClient;

    constructor(tmHttp: TmHttpClient) {
        this.http = createSwaggerClient(tmHttp, HttpClient);
    }

    /**
     * No description
     *
     * @tags Countries
     * @name CountriesGet
     * @summary Gets all Countries.
     * @request GET:/countries
     */
    countriesGet = (params: RequestParams = {}) =>
        this.http.request<CountryModelDto[], any>({
            path: `/countries`,
            method: 'GET',
            format: 'json',
            ...params,
        });
}
